import { atom } from 'jotai'

export const dirtyModelAtom = atom({})
export const logoFileAtom = atom(null)
